import { Mutation, Visitor } from 'graphql/generated/graphqlTypes';
import { generateMockVisitor } from 'mocks/graphqlMocks/visitor';

export function mockedUnsetInstallerByIdData(unsetInstallerById: Visitor): Pick<Mutation, 'unsetInstallerById'> {
  return {
    unsetInstallerById
  };
}

export const mockedUnsetInstallerDataDataForMutation = mockedUnsetInstallerByIdData(
  generateMockVisitor({
    id: 'mockedVisitorIdInstaller1',
    name: 'mockedVisitorNameInstaller1',
    email: 'mockedVisitorEmailInstaller1'
  })
);
